import { CardBrandLogo } from "@/features/patient/components/patient-details-drawer";
import formatExpiry from "@/features/payment/utils/formatExpiry";
import { PaymentCard } from "../types";

interface CardViewProps {
  card: PaymentCard;
  fallbackName?: string;
}

export function CardView({ card, fallbackName }: CardViewProps) {
  return (
    <>
      {card.brand && <CardBrandLogo brand={card.brand} size="md" />}

      <div className="flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-[#111827]">{card.last4}</span>
          <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-[10px] font-semibold text-[#6B7280]">
            Card on File
          </span>
        </div>
        <div className="mt-[3px] text-xs font-medium text-[#6B7280]">
          {card.cardHolderName || fallbackName} &bull;{" "}
          {formatExpiry(card.expMonth ?? 0, card.expYear ?? 0)}
        </div>
      </div>
    </>
  );
}
